import { Box, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getAccessoriesByCategories, getProductById } from "../api/products/products";
import { Product } from "../types";
import PageTitle from "../components/PageTitle";
import SelectLooseProducts from "../components/Selection/SelectLooseProducts";

const ProductConfigureContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,

  overflowY: "auto",

  display: "flex",
  flexDirection: "column",

  height: "calc(100vh - 72px - 65px)",

  margin: "0 auto 16px",
  padding: "16px 96px",

  [theme.breakpoints.down("md")]: {
    height: "calc(100vh - 114px)",
    padding: "12px 12px 0",
  },
}));

const AccessorySelection: React.FC = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState<Product | null>(null);

  const getProduct = async () => {
    if (!productId) {
      return null;
    }
    try {
      const response = await getProductById(productId);
      setProduct(response);
    } catch (error) {
      console.error(`Error fetching product: ${error}`);
      return null;
    }
  };

  useEffect(() => {
    getProduct();
  }, [productId]);

  return (
    <ProductConfigureContainer component="main" id="scroll-box">
      <PageTitle
        title={product?.name ?? ""}
        subtitle="Select accessories to add to your purchase order"
        imageUrl={product?.imageUrl}
      />

      <SelectLooseProducts get={getAccessoriesByCategories} />
    </ProductConfigureContainer>
  );
};

export default AccessorySelection;
